// Tedarikçi Cari Eşleştirme penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'documents.eInvoiceAccountMatch';

export const eInvoiceAccountMatchGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Tedarikçi cari nasıl eşleştirilir?'),
  intro: t(`${G}.intro`, 'İçeri aktardığınız e-faturanın tedarikçisini cari hesaplarınızdan biriyle eşleştirirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Tedarikçi ve cari seçimi'),
    footer: t(`${G}.regions.footer`, 'Onayla'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu pencere ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Gelen e-faturayı alış faturasına çevirirken ilk adım budur: faturanın hangi cariye yazılacağını belirlersiniz. Bu pencere kayıt oluşturmaz, cari bakiyesini değiştirmez; yalnız cariyi seçer.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. E-faturadaki tedarikçi bilgilerine bakın'),
      text: t(`${G}.s2.text`, '"E-Faturadan Gelen Tedarikçi Bilgileri" kutusunda firma adı, VKN, vergi dairesi, telefon, e-posta ve adres görünür. Bilgi okunamadıysa uyarı çıkar; cariyi elle seçin veya yeni ekleyin.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Otomatik eşleşmeyi kontrol edin'),
      text: t(`${G}.s3.text`, 'Sistem önce VKN ile, bulamazsa firma adıyla carilerinizde arar ve bulduğunu kendiliğinden seçer. Seçilen cari yeşil "Seçili Cari Hesap" kutusunda görünür; doğru olup olmadığını kontrol edin.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Cariyi değiştirin veya yeni ekleyin'),
      text: t(`${G}.s4.text`, '"Cari Hesap Ara" kutusunda firma adı veya VKN ile arayıp başka bir cari seçebilirsiniz. Cari yoksa "Yeni Cari Ekle" e-faturadaki bilgilerle dolu bir cari kartı açar; kaydedince liste yenilenir; henüz cari seçili değilse yeni cari VKN\'sinden bulunup kendiliğinden seçilir.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Onaylayın ve devam edin'),
      text: t(`${G}.s5.text`, '"Cariyi Onayla ve Devam Et" (cari seçilince açılır) cariyi alış faturasına yazar ve ardından "E-Fatura Ürünlerini Aktar" penceresini açar. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
